export class VideoAnalytics {
  constructor() {
    this.mediaControllers = document.querySelectorAll("media-controller");
    this.init();
  }

  init() {
    if (!this.mediaControllers.length) return;

    this.mediaControllers.forEach((mediaController) => {
      this.setupVideoTracking(mediaController);
    });
  }

  setupVideoTracking(mediaController) {
    const video = mediaController.querySelector(
      "video, vimeo-video, youtube-video"
    );

    if (!video) return;

    const videoName = this.getVideoName(video);
    const handleVideoPlay = () => this.trackVideoPlay(videoName);

    video.addEventListener("play", handleVideoPlay);
  }

  getVideoName(videoElement) {
    const tagName = videoElement.tagName.toLowerCase();

    switch (tagName) {
      case "vimeo-video":
        return videoElement.getAttribute("src") || "Vimeo Video";

      case "youtube-video":
        return videoElement.getAttribute("src") || "YouTube Video";

      default:
        const src = videoElement.src || videoElement.currentSrc;
        return src ? src.split("/").pop() : "Unknown Video";
    }
  }

  trackVideoPlay(videoName) {
    const eventData = {
      event: "video_play",
      page_location: window.location.href,
      video_title: videoName,
    };

    try {
      if (window.dataLayer && Array.isArray(window.dataLayer)) {
        console.log(eventData);
        window.dataLayer.push(eventData);
      }
    } catch (error) {
      console.warn(
        "Failed to send video play event to Google Tag Manager:",
        error
      );
    }
  }
}
